import { render, staticRenderFns } from "./formDistrictSettingDialog.vue?vue&type=template&id=525ff76d&scoped=true"
import script from "./formDistrictSettingDialog.vue?vue&type=script&lang=js"
export * from "./formDistrictSettingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ff76d",
  null
  
)

export default component.exports